export const languageCode = 'ja';
export const languageLabel = 'Japanese';

export const translations = {
  AUDIO_DESCRIPTION_OFF: 'オフ',

  CAPTIONS_BACK_TO_CAPTIONS_MENU: 'Back to captions menu',
  CAPTIONS_CAPTIONS_SETTINGS_RESET_DEFAULTS: 'Captions settings reset to defaults',
  CAPTIONS_CHARACTER_EDGE_STYLE: 'Character edge style',
  CAPTIONS_CHARACTER_EDGE_STYLE_CLOSE: 'Close character edge style menu',
  CAPTIONS_CHARACTER_EDGE_STYLE_OPEN: 'Open character edge style menu',
  CAPTIONS_CLOSE_TRANSCRIPT: 'Search Video - close transcript viewer',
  CAPTIONS_DISABLED: 'No captions available',
  CAPTIONS_FONT_FAMILY: 'Font family',
  CAPTIONS_FONT_FAMILY_CLOSE: 'Close Font Family Menu',
  CAPTIONS_FONT_FAMILY_OPEN: 'Open Font Family Menu',
  CAPTIONS_HIDE_MENU: 'キャプションメニューを隠す',
  CAPTIONS_OFF: 'オフ',
  CAPTIONS_OPEN_TRANSCRIPT: 'Search Video - open transcript viewer',
  CAPTIONS_READ_TRANSCRIPT: '動画検索',
  CAPTIONS_SHOW_MENU: 'キャプションメニューを表示する',
  CAPTIONS_TURN_OFF: 'Turn off captions',
  CAPTIONS_TURN_ON: 'Turn on captions',

  CHAPTERS_CLOSE_CHAPTERS: 'チャプターを閉じる',
  CHAPTERS_OPEN_CHAPTERS: 'チャプターを開く',

  CLICK_FOR_SOUND_DESKTOP_TEXT: '音を出すにはクリックしてください。',
  CLICK_FOR_SOUND_MOBILE_TEXT: '音をだすにはタップしてください。',

  CONTEXT_MENU_ABOUT_WISTIA: 'Wistiaについて',
  CONTEXT_MENU_COPIED: 'コピーされました！',
  CONTEXT_MENU_COPY_LINK_AND_THUMBNAIL: 'リンクとサムネイルをコピーする',
  CONTEXT_MENU_LOGGED_IN_TO_WISTIA: 'Wistiaにログインしました',
  CONTEXT_MENU_OPEN_VIDEO_IN_WISTIA: 'Wistiaのビデオを開く',
  CONTEXT_MENU_REPORT_A_PROBLEM: '問題を報告',
  CONTEXT_MENU_VIEW_STATS_IN_WISTIA: 'ウィスティアの統計情報を見る',

  CUSTOMER_LOGO_LOGO: 'ロゴ',

  ENTER_PASSWORD_PHRASE: 'Please enter your password.',

  FULLSCREEN_DOUBLE_TAP: 'Double-tap to zoom in or out',
  FULLSCREEN_TITLE_WHEN_IN_FULLSCREEN: '全画面表示を解除',
  FULLSCREEN_TITLE_WHEN_NOT_IN_FULLSCREEN: '全画面表示',

  INCORRECT_PASSWORD: 'Incorrect Password',

  LAYOUT_TITLE: 'ビデオ',

  PASSWORD: 'Password',

  PLAY: 'Play',

  PLAY_BUTTON_LIVE_NOT_STARTED: 'Livestream has not started',
  PLAY_BUTTON_TITLE_WHEN_NOT_PLAYING: '再生',
  PLAY_BUTTON_TITLE_WHEN_PLAYING: '一時停止',

  REPORT_A_PROBLEM_ADD_DETAILS_TEXT: '詳細を追加してください',
  REPORT_A_PROBLEM_CANCEL: 'Cancel',
  REPORT_A_PROBLEM_CHOOSE_ONE: '1つを選択',
  REPORT_A_PROBLEM_DESCRIPTION:
    '問題を報告していただきありがとうございます。 このセッションに関する技術データを添付して、問題を把握するのに役立てます。 この中で問題に、最もあてはまる説明は何ですか？',
  REPORT_A_PROBLEM_DISMISS: '却下する',
  REPORT_A_PROBLEM_FAILS_TO_PLAY: '動画が再生されない',
  REPORT_A_PROBLEM_OTHER: 'その他',
  REPORT_A_PROBLEM_OTHER_CONTEXT: 'その他の詳細や文脈は？',
  REPORT_A_PROBLEM_POOR_QUALITY: '動画の品質が悪い',
  REPORT_A_PROBLEM_PROBLEM_CATEGORY: '問題のカテゴリ',
  REPORT_A_PROBLEM_PROBLEM_DESCRIPTION: '問題の説明',
  REPORT_A_PROBLEM_SELECT_CAT_TEXT: 'カテゴリを選択してください',
  REPORT_A_PROBLEM_SEND: '送信',
  REPORT_A_PROBLEM_SENDING: '送信中...',
  REPORT_A_PROBLEM_STUTTER: '動画は再生されますが、よく止まる',

  REWATCH: '再視聴',

  SETTINGS_PLAYBACK_RATE_TITLE: 'スピード',
  SETTINGS_QUALITY_AUTO: '自動',
  SETTINGS_QUALITY_TITLE: '品質',
  SETTINGS_TITLE: 'Settings',

  SHARE_CONTROL_CLOSE: '共有メニューを閉じる',
  SHARE_CONTROL_OPEN: '共有メニューを開く',
  SHARE_COPIED: 'コピーされました！',
  SHARE_DOWNLOAD: 'ダウンロード',
  SHARE_EMAIL: 'Eメール',
  SHARE_EMBED: '埋め込み',
  SHARE_FACEBOOK: 'フェイスブック',
  SHARE_LINKED_IN: 'LinkedIn',
  SHARE_TWITTER: 'Twitter',

  SKIP: '飛ばす',

  STATUS_BAR_EMBED_CODE_COPIED: '埋め込みコードはクリップボードにコピーされました！',

  THUMBNAIL_VIDEO_THUMBNAIL: 'ビデオサムネイル',

  TURNSTILE_DEFAULT_END: 'ご視聴ありがとうございます！ \nメールアドレスを入力してください。',
  TURNSTILE_DEFAULT_START: 'この動画を見るには、メールアドレスを入力してください。',
  TURNSTILE_EMAIL_PLACEHOLDER: 'お使いのメール',
  TURNSTILE_FIRST_NAME_PLACEHOLDER: '名',
  TURNSTILE_LAST_NAME_PLACEHOLDER: '姓',
  TURNSTILE_PLAY: '再生',
  TURNSTILE_SUBMIT: '提出する',
  TURNSTILE_VENDOR_FIELD_ERROR: 'Please fill out ',

  VOLUME_TITLE_VOLUME_SLIDER: '音量調節',
  VOLUME_TITLE_WHEN_MUTED: 'ミュート解除',
  VOLUME_TITLE_WHEN_UNMUTED: 'ミュート',

  WATCH_NEXT_NEXT_VIDEO_PLAYS_IN: '次の動画の再生先…',
};
